module.exports = __webpack_public_path__ + "img/gb.b4ee1efe.svg";